import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { formatDatetime } from './utils/datetime';

Date.prototype.toJSON = function() {
    return formatDatetime(this);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <App />
);
